
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/builds/devhacker/burninghut/bh-frontend/sentry.client.config.ts")
            }
          });